import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Form,
  Input,
  Spin,
  Button,
  Card,
  message,
  Layout,
  Checkbox,
} from 'antd'
import { UserOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { Redirect, Link,useLocation,useHistory } from 'react-router-dom'
import '../../css/signin.scss'
import util from '../../util/util'
import { loginWithOtp, resendOtp } from '../../store/action/profile.action'
import { constants } from '../../constants'
import logo from '../../logo.png'
import { isEmpty } from 'lodash'
import { requestToken } from '../../config/firebase'
import { useToast } from '../../hooks'
import { setWebToken } from '../../store/action/notification.action'
import { setUserDeviceToken } from '../../store/action/device.action'

var cardSize =
  (window.innerWidth < window.innerHeight
    ? window.innerWidth
    : window.innerHeight) - 20

cardSize = cardSize < 400 ? cardSize : 400

const Otpverification = (props) => {
    var location = useLocation();
      var history = useHistory()
   let isAdminLite=location?.search==constants.ADMIN_LITE;
  const [isDisabled, setIsDisabled] = useState(false)
  const [timeLeft, setTimeLeft] = useState(0)
  const [fbToken, setFbToken] = useState(false)
  const [isTrusted, setTrust] = useState(false)

  const onFinish = async (values) => {
    try{
    const res= await props.loginWithOtp({
      otpFromPatient: values.otp,
      userid: props.user._id,
      deviceType:isAdminLite?constants.APPLICATION.AdminLite:constants.APPLICATION.AdminWeb,
      location:props.location,
      device:props.device,
      isTrusted 
    })

    
    if(isAdminLite){
      if(res.trustToken){
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            route: '/setcookie',
            data: {
              trustToken:res.trustToken 
              // trustToken:`trustToken=${res.trustToken}; Max-Age=${res.exp}; Path=/;` 
            }
          })
        );
      }

      const data={token:res?.token,email:res?.user?.email}
       const path=`/messages${constants.ADMIN_LITE}`
       history.push({ pathname: '/messages',search: constants.ADMIN_LITE })
        
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          route: '/navigate',
          data: { path }  
        })
      );

      window.ReactNativeWebView.postMessage(
        JSON.stringify({ route: '/setprofile', data })
      )

      await props.setUserDeviceToken({userid: props.user._id})
    }
  }
  catch(err){
    console.log(err,"Error in loginWithOtp")
  }

  }

  useEffect(() => {
    if (props.encToken) getToken()
  }, [props.encToken])

  const resendOtp = async () => {
    if (props.user?._id) await props.resendOtp(props.user._id)
    setIsDisabled(true)
    setTimeLeft(30)

    const countdown = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(countdown)
          setIsDisabled(false)
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }
  var { ROLE } = constants

  const { successToast } = useToast()

  const getToken = async () => {
    if (!props.webtoken) {
      console.log('app requestPermission')
      const permission = await Notification.requestPermission()
      console.log(permission, permission === 'granted', 'app requestPermission')
      if (permission === 'granted') {
        const webtoken = await requestToken()
        console.log(webtoken, permission === 'granted', 'app requestPermission')
        if (webtoken) {
          console.log(permission, 'app requestPermission')
          await props.setWebToken({
            webtoken,
            timezone: util.getTimeZoneOffsetInHour(),
          })
        }
      } else {
        console.log('user cancelled the notification request')
      }

      setFbToken(true)
    }
  }
  const handleBack = async () => {
    const path = `/login${constants.ADMIN_LITE}`;
    await history.push({ pathname: '/login', search: constants.ADMIN_LITE });
    await window.ReactNativeWebView.postMessage(
      JSON.stringify({
        route: '/navigate',
        data: { path }
      })
    );
  };
  // useEffect(() => {

  // //   getToken();
  //   onMessageListener().then(notification => {
  //     if (notification && !isEmpty(notification)) {
  //       successToast(notification.body)
  //       // setNotification({title: notification.title, body: notification.body})
  //     }
  //     console.log(notification);
  //   }).catch(err => console.log('failed: ', err));
  // }, []);

  return props.token == undefined && !props.user?._id ? (
    <Redirect to='/login' />
  ) : props.token != undefined ? (
    props.token.role == ROLE.COMPANY_ADMIN ||
    props.token.role == ROLE.COMPANY_HEALTHCOACH ? (
      <Redirect to='/customers' />
    ) : props.token.role == ROLE.SUPER_ADMIN ? (
      <Redirect to='/companies' />
    ) : props.token.role == ROLE.SURGEON ? (
      // <Redirect to="/profile/?myprofile=true" /> : <Redirect to="/home" />) :
      <Redirect to='/profile/?myprofile=true' />
    ) : isAdminLite?(
      <Redirect to={{ pathname: "/messages", search: "app=admin-lite" }} />
    ):(
      <Redirect to='/compliance' />
    )
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Row type='flex' align='middle' className='signinRow center'>
          <Col span={24} flex='auto'>
            <div className='signinContainer'>
              <Card style={{ width: cardSize }}>
                <div className='imageBox center'>
                  <img
                    src={logo}
                    width={cardSize / 2}
                    style={{ paddingBottom: cardSize / 20 }}
                  />
                </div>
                <h2>
                  {' '}
                 {!isAdminLite  && <Link style={{ color: 'black' }} 
                  to= '/login'
                  >
                    <ArrowLeftOutlined />
                  </Link>}{' '}
                  {isAdminLite &&  <ArrowLeftOutlined onClick={handleBack}/>}
                  &nbsp; Sign in
                </h2>
                <div>Please enter your OTP.</div>
                <div style={{ color: 'gray', fontSize: '12px' }}>
                  OTP sent to {props.user?.email}
                </div>
                <Form
                  name='normal_login'
                  className='login-form'
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                >
                  <Row justify={'end'}>
                    <Col style={{ marginRight: 'auto' }} flex={'75%'}>
                      <Form.Item
                        name='otp'
                        rules={[
                          {
                            required: true,
                            message: 'Please enter one time password!',
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder='Enter Your OTP'
                          maxLength={6}
                        />
                      </Form.Item>
                      <div className='resendOtp'>
                        
                      <a
                        onClick={resendOtp}
                        style={{
                          pointerEvents: isDisabled ? 'none' : 'auto',
                          color: isDisabled ? 'gray' : 'blue',
                        }}
                      >
                        Resend OTP
                      </a>
                          <Checkbox onChange={(e) =>setTrust(e.target.checked)}>Trust this device</Checkbox>
                          </div>
                      <span style={{ color: 'gray' }}>
                        {isDisabled ? ` in ${timeLeft}s` : ''}
                      </span>
                    </Col>
                    <Col flex={'20%'}>
                      <Form.Item>
                        <Button
                          style={{ width: '100%' }}
                          type='primary'
                          htmlType='submit'
                          className='login-form-button'
                        >
                          Send
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Card>
            </div>
            <Layout.Footer className='main-footer'>
              {util.getCopyrightText()}
            </Layout.Footer>
          </Col>
        </Row>
      </Spin>
    </>
  )
}

Otpverification.propTypes = {
  // loginUser: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  webtoken: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    hasError: state.profile.error,
    message: state.profile.message,
    isLoading: state.profile.isLoading,
    token: util.verifyToken(state.profile.token, true),
    user: state.profile.user,
    webtoken: state.notification.webtoken,
    encToken: state.profile.token,
    location:state.device.location,
    device:state.device.device,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginWithOtp: (input) => dispatch(loginWithOtp(input)),
    resendOtp: (input) => dispatch(resendOtp(input)),
    setWebToken: (input) => dispatch(setWebToken(input)),
    setUserDeviceToken: (input) => dispatch(setUserDeviceToken(input)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Otpverification)
